module.exports = __webpack_public_path__ + "img/sophie-even.c22dbf04.jpg";